import { memo } from 'react';
export default /*#__PURE__*/memo(_ref => {
  let {
    children
  } = _ref;
  return children;
});
//# sourceMappingURL=Expanded.js.map